import type { Doc } from "building-types/doc";
import type { ElectricalRuleHandle, SettingsHandle } from "building-types/handles/docEntityHandleTypes";
import type { ElectricalRule } from "building-types/settings/electricalRuleTypes";
import type { ElectricalSettings } from "building-types/settings/electricalSettings";

export function docGetElectricalRule(doc: Doc, item: ElectricalRuleHandle): ElectricalRule | null {
  const setting = doc.settings[item.settingsHandle.id];
  if (!setting) {
    return null;
  }
  const rule = (setting as ElectricalSettings).rules?.[item.id];
  if (!rule) {
    return null;
  }
  return rule;
}

export function docGetElectricalRuleParent(item: ElectricalRuleHandle): SettingsHandle {
  return item.settingsHandle;
}
